const setSuitabilityTestScore = (val = null) => {
  return {
    type: 'SET_SUITABILITYTESTSCORE',
    data: val,
  }
}

export default {
  setSuitabilityTestScore,
}